import { makeObservable } from 'mobx'
import { type IResponseRecurringChildBroadcast } from 'entities/Broadcast/api/types'
import { BroadcastOneTime } from 'entities/Broadcast/model/BroadcastOneTime'
import type { IEntitiesStore } from 'entities/EntitiesExport'

type IBroadcastRecurringChildProps = {
  item: IResponseRecurringChildBroadcast
  parentId: number
  entities: IEntitiesStore
}

export class BroadcastRecurringChild extends BroadcastOneTime {
  parentId: number
  recurring_template_settings: IResponseRecurringChildBroadcast['recurring_template_settings']

  constructor({ item, parentId, entities }: IBroadcastRecurringChildProps) {
    super({ ...item, recurring_template_settings: null }, entities)
    this.parentId = parentId
    this.recurring_template_settings = item.recurring_template_settings
    makeObservable(this, {})
  }
}
